export const CALLING_TABS = [
  { label: 'Outbound Call Charges', value: 'outgoing' },
  { label: 'Inbound Call Charges', value: 'incoming' },
];

export const INCOMING_CALL_PRICING_HEADERS = [
  { label: 'Phone Number Type', key: 'phoneNumberType', width: 6, infoIcon: true, tooltip: 'Charges applicable when a call is received to SuperAGI number' },
  { label: 'Credit Charges (per minute)', key: 'incomingRate', width: 6 },
];

export const OUTGOING_CALL_PRICING_HEADERS = [
  {
    label: 'Calls made to this Region',
    key: 'routeDescription',
    width: 5,
    infoIcon: true,
    tooltip: 'Charges applicable when a call is made to this region based on origination and destination prefix',
  },
  { label: 'Origination Prefixes', key: 'originationPrefixes', width: 2 },
  { label: 'Destination Prefixes', key: 'destinationPrefixes', width: 2 },
  { label: 'Credit Charges (per minute)', key: 'creditCharges', width: 3 },
];
